import { Component, OnInit, ViewContainerRef, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { YoutubeVideoComponent } from '../youtube-video/youtube-video.component';
import { TextBoxComponent } from '../text-box/text-box.component';
import { UrlBoxComponent } from '../url-box/url-box.component';
import { ImageComponent } from '../image/image.component';
import { SliderComponent } from '../slider/slider.component';
import { VideoComponent } from '../video/video.component';
import { CardsComponent } from '../cards/cards.component';
import { NewPageList } from '../../core/models/new-page-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ListComponent } from '../list/list.component';
import { ListWithinList } from '../../core/models/list-within-list';
import { StaticCompComponent } from '../static-comp/static-comp.component';
import { SpeakerSelectComponent } from '../speaker-select/speaker-select.component';
import { ChairpersonSelectComponent } from '../chairperson-select/chairperson-select.component';
import { CoordinatorSelectComponent } from '../coordinator-select/coordinator-select.component';
import { PanelistSelectComponent } from '../panelist-select/panelist-select.component';
import { ModeratorSelectComponent } from '../moderator-select/moderator-select.component';
import { AlternateSpeaker1SelectComponent } from '../alternate-speaker1-select/alternate-speaker1-select.component';
import { AlternateSpeaker2SelectComponent } from '../alternate-speaker2-select/alternate-speaker2-select.component';
import { AlternateSpeaker3SelectComponent } from '../alternate-speaker3-select/alternate-speaker3-select.component';
@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
  providers: [NewPageService]
})
export class DropDownComponent implements OnInit {

  @ViewChild('template', { read: ViewContainerRef }) template: ViewContainerRef;
  listing: boolean = true;
  message: string;
  eventId: string;
  show: boolean = true;
  _ref: any;
  cmCategory: string;
  aboutUs = new NewPageList();
  TAG = "drop-down.component.ts"


  constructor(private _cfr: ComponentFactoryResolver, private newPageService: NewPageService) {

  }

  ngOnInit() {
  }

  addSpeaker(speakerList) {
    console.log(speakerList)

    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(SpeakerSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'speaker';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'speaker';
      expComponent.instance.selectorTitle = 'Speaker';
      expComponent.instance.hasText = 'Has Selected Speakers?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'speaker';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'speaker';
      expComponent.instance.selectorTitle = 'Speaker';
      expComponent.instance.hasText = 'Has Selected speakers?';
    }
  }

  addChairperson(speakerList) {
    console.log(speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(ChairpersonSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'chairperson';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'chairperson';
      expComponent.instance.selectorTitle = 'Chairperson';
      expComponent.instance.hasText = 'Has Selected Chairpersons?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'chairperson';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'chairperson';
      expComponent.instance.selectorTitle = 'Chairperson';
      expComponent.instance.hasText = 'Has Selected Chairpersons?';
    }
  }
  addCoordinator(speakerList) {
    // console.log(this.TAG, speakerList)

    console.log(speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(CoordinatorSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'coordinator';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'coordinator';
      expComponent.instance.selectorTitle = 'Coordinator';
      expComponent.instance.hasText = 'Has Selected coordinator?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'coordinator';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'coordinator';
      expComponent.instance.selectorTitle = 'Coordinator';
      expComponent.instance.hasText = 'Has Selected coordinators?';
    }
  }
  addPanelist(speakerList) {
    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(PanelistSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'panelist';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'panelist';
      expComponent.instance.selectorTitle = 'Panelist';
      expComponent.instance.hasText = 'Has Selected panelist?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'panelist';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'panelist';
      expComponent.instance.selectorTitle = 'Panelist';
      expComponent.instance.hasText = 'Has Selected panelists?';
    }
  }
  addModerator(speakerList) {
    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(ModeratorSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'moderator';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'moderator';
      expComponent.instance.selectorTitle = 'Moderator';
      expComponent.instance.hasText = 'Has Selected moderator?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'moderator';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'moderator';
      expComponent.instance.selectorTitle = 'Moderator';
      expComponent.instance.hasText = 'Has Selected moderators?';
    }
  }
  addAlternateSpeaker1(speakerList) {
    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(AlternateSpeaker1SelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker1';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker1';
      expComponent.instance.selectorTitle = 'Alternate Speaker 1';
      expComponent.instance.hasText = 'Has Selected alternatespeaker1?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker1';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker1';
      expComponent.instance.selectorTitle = 'Alternate Speaker 2';
      expComponent.instance.hasText = 'Has Selected Alternate Speaker 1?';
    }
  }

  addAlternateSpeaker2(speakerList) {
    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(AlternateSpeaker2SelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker2';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker2';
      expComponent.instance.selectorTitle = 'Alternate Speaker 2';
      expComponent.instance.hasText = 'Has Selected Alternate Speaker 2?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker2';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker2';
      expComponent.instance.selectorTitle = 'Alternate Speaker 2';
      expComponent.instance.hasText = 'Has Selected Alternate Speaker 2?';
    }
  }
  addAlternateSpeaker3(speakerList) {
    // console.log(this.TAG, speakerList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(AlternateSpeaker3SelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    if (speakerList !== null) {
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker3';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker3';
      expComponent.instance.selectorTitle = 'Alternate Speaker 3';
      expComponent.instance.hasText = 'Has Selected Alternate Speaker 3?';
      expComponent.instance.speakerList = speakerList
      const checkBoxSpeaker = new Array(speakerList.length)
      for (let i = 0; i < speakerList.length; i++) {
        if (this.aboutUs.specificSpeakersList && this.aboutUs.specificSpeakersList.includes(speakerList[i].$key)) {
          checkBoxSpeaker[i] = true
        }
      }
      expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
      this.listing = false;
    }
    else {
      
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'alternatespeaker3';
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.aboutUsType = 'alternatespeaker3';
      expComponent.instance.selectorTitle = 'Alternate Speaker 3';
      expComponent.instance.hasText = 'Has Selected Alternate Speaker 3?';
    }
  }

  addTopic(topicList) {
    console.log(this.TAG, topicList)
    var speakerSelectBox = this._cfr.resolveComponentFactory(SpeakerSelectComponent);
    var expComponent = this.template.createComponent(speakerSelectBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'topics';
    expComponent.instance.aboutUs = this.aboutUs;
    expComponent.instance.selectorTitle = 'Topics';
    expComponent.instance.aboutUsType = 'topics';
    expComponent.instance.speakerList = topicList
    expComponent.instance.hasText = 'Has Specific Topic?';
    const checkBoxSpeaker = new Array(topicList.length)
    for (let i = 0; i < topicList.length; i++) {
      // alert(topicList[i].$key)
      if (this.aboutUs.specificTopicsList && this.aboutUs.specificTopicsList.includes(topicList[i].$key)) {
        checkBoxSpeaker[i] = true
      }
    }
    expComponent.instance.checkBoxSpeaker = checkBoxSpeaker
    this.listing = false;
  }

  addYoutube() {
    var youtube = this._cfr.resolveComponentFactory(YoutubeVideoComponent);
    var expComponent = this.template.createComponent(youtube);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventYouTubeVideo = false;
    }
    expComponent.instance.eventId = this.eventId;
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'youtubeVideo';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addTextBox() {
    var textBox = this._cfr.resolveComponentFactory(TextBoxComponent);
    var expComponent = this.template.createComponent(textBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventText = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'text';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addUrlBox() {
    var urlBox = this._cfr.resolveComponentFactory(UrlBoxComponent);
    var expComponent = this.template.createComponent(urlBox);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventURL = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'url';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addImage() {
    var image = this._cfr.resolveComponentFactory(ImageComponent);
    var expComponent = this.template.createComponent(image);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventImage = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'image';
    expComponent.instance.eventId = this.eventId;
    expComponent.instance.cmCategory = this.cmCategory;
    expComponent.instance.aboutUs = this.aboutUs;
    expComponent.instance.message = this.message;
    this.listing = false;
  }

  addImageSlider() {
    console.log(this.cmCategory, 'image Slider');
    var imageSlider = this._cfr.resolveComponentFactory(SliderComponent);
    var expComponent = this.template.createComponent(imageSlider);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventSlider = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'imageSlider';
    expComponent.instance.eventId = this.eventId;
    expComponent.instance.cmCategory = this.cmCategory;
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addVideo() {

    if (this.aboutUs.contentMandatoryList[0]) {
      this.newPageService.getContentsMandatory(this.aboutUs.contentMandatoryList[0], this.eventId).subscribe((conMan) => {
        this.newPageService.getFile(conMan, this.eventId).then((url) => {
          var video = this._cfr.resolveComponentFactory(VideoComponent);
          var expComponent = this.template.createComponent(video);
          expComponent.instance._ref = this._ref;
          this.aboutUs.type = 'video';
          expComponent.instance.eventId = this.eventId;
          expComponent.instance.cmCategory = this.cmCategory;
          expComponent.instance.aboutUs = this.aboutUs;
          expComponent.instance.src = url;
          this.listing = false;
        });
      });
    } else {
      var video = this._cfr.resolveComponentFactory(VideoComponent);
      var expComponent = this.template.createComponent(video);
      expComponent.instance._ref = this._ref;
      this.aboutUs.type = 'video';
      expComponent.instance.eventId = this.eventId;
      expComponent.instance.cmCategory = this.cmCategory;
      expComponent.instance.aboutUs = this.aboutUs;
      expComponent.instance.eventVideos = false;
      this.listing = false;
    }
  }

  addCards() {
    var cards = this._cfr.resolveComponentFactory(CardsComponent);
    var expComponent = this.template.createComponent(cards);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventCard = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'cards';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addList() {
    var list = this._cfr.resolveComponentFactory(ListComponent);
    var expComponent = this.template.createComponent(list);
    if (this.aboutUs.type == null || this.aboutUs.type.trim().length < 1) {
      expComponent.instance.eventList = false;
    }
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = 'list';
    expComponent.instance.aboutUs = this.aboutUs;
    this.listing = false;
  }

  addStatic(value: string) {
    var staticComp = this._cfr.resolveComponentFactory(StaticCompComponent);
    var expComponent = this.template.createComponent(staticComp);
    expComponent.instance._ref = this._ref;
    this.aboutUs.type = value;
    expComponent.instance.aboutUs = this.aboutUs;
    // this.listing = false;
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/drop-down/drop-down.component.ts